import { useMemo } from "react";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { ConvertUtils } from "../../../../../../common/utils/convert";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Props
 */

type Props = {
  field: number | null;
  value: string | null;
  status: number | null;
  onFieldChange: (value: number | null) => void;
  onValueChange: (value: string | null) => void;
  onStatusChange: (value: number | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  field,
  value,
  status,
  onFieldChange,
  onValueChange,
  onStatusChange,
  onClearFilters,
}: Props) => {

  const fieldOptions = useMemo(() => {
    return [
      { id: 1, label: 'Código' },
      { id: 2, label: 'Descrição' },
    ];
  }, [
  ]);

  const statusOptions = useMemo(() => {
    return [
      { id: 2, label: 'Todos' },
      { id: 1, label: 'Ativos' },
      { id: 0, label: 'Inativos' },
    ];
  }, [
  ]);

  return (
    <CascateList title='Filtros' defaultOpen={true}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full grid grid-cols-1 xl:grid-cols-3 gap-x-2 gap-y-4">
          <div className="w-full flex flex-row col-span-1 xl:col-span-2 gap-1">
            <div className="w-[20rem]">
              <DefaultSelectInput
                name='field'
                label='Por'
                showSelectionLabel={false}
                options={fieldOptions}
                value={field}
                onChangeValue={e => onFieldChange(ConvertUtils.toNumber(e))}
              />
            </div>

            <DefaultInput
              name='value'
              label='Campo'
              value={value}
              onChangeValue={onValueChange}
            />
          </div>

          <DefaultSelectInput
            name='status'
            label='Status'
            showSelectionLabel={false}
            options={statusOptions}
            value={status}
            onChangeValue={e => onStatusChange(ConvertUtils.toNumber(e))}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}